import { Page } from '@/core/architecture'

import { DeactivationConfirmTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * DeactivationConfirm Page
 * Implemented as a practical sample.
 */
export const DeactivationConfirm: Page = () => {
  const { state, actions } = useViewModel()

  return <DeactivationConfirmTemplate state={state} {...actions} />
}
